import styled from 'styled-components'

const HERO_IMAGE_WIDTH = 530

export const ChangelogReleaseStyled = styled.article`
  display: grid;
  grid-template-columns:
    minmax(0, ${(props) => props.theme.typography.pxToRem(HERO_IMAGE_WIDTH)})
    minmax(0, 1fr);
  gap: ${(props) => props.theme.space.large};
  align-items: start;

  @media (max-width: ${(props) => props.theme.typography.pxToRem(1160)}) {
    grid-template-columns: minmax(0, 1fr);
  }
`
